import { CreateWatchlist } from '@unistocks/features/watchlists/create-watchlist';
import { t } from '@unistocks/localization';
import Head from 'expo-router/head';

export default function CreateWatchlistScreen() {
  return (
    <>
      <Head>
        <title>{t('::Menu:Watchlists:Create')}</title>
      </Head>
      <CreateWatchlist />
    </>
  );
}
